import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import Navbar from './Components/nav/Nav';
import Topheader from './Components/topheader/Topheader';
import Header from './Components/header/Header';
import Aboutmain from './Components/about/About';
import Construction from './Components/construction/Construction';
import Realestate from './Components/realestate/Realestate';
import Otherservice from './Components/Otherserivice/Otherservice';
import Contact from './Components/conatct/Contact';
import Footer from './Components/Footer/Footer';
import Gallery from './Components/gallery/galley';
import Thankspage from './Components/Thankyoupage/Thankyou';
import ContactPage from './Components/newcontactpage/Newcontactpag';

function AppContent() {
  const location = useLocation();
  const hideLayout = location.pathname === "/thankyou";

  return (
    <>
      {!hideLayout && <Topheader />}
      {!hideLayout && <Navbar />}

      <div className="content">
        <Routes>
          <Route path="/" element={<Header />} />
          <Route path="/aboutmain" element={<Aboutmain />} />
          <Route path="/construction" element={<Construction />} />
          <Route path="/realestate" element={<Realestate />} />
          <Route path="/Otherservice" element={<Otherservice />} />
          <Route path="/contact" element={<ContactPage/>} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/thankyou" element={<Thankspage />} />
        </Routes>
      </div>

      {!hideLayout && <Footer />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
